import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import "primeicons/primeicons.css";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Textarea from "@mui/joy/Textarea";
import useBlogCalls from "../service/useBlogCalls";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const status = [
  { name: "Draft", value: false },
  { name: "Published", value: true },
];

const NewBlog = () => {
  const { getData, postBlog,getCategoryName } = useBlogCalls();
  const { categories } = useSelector((state) => state.blog);
  const navigate = useNavigate();
  console.log(categories);

  const initialValue = {
    categoryId: "",
    title: "",
    content: "",
    image: "",
    isPublish: false,
  };
  const [blog, setBlog] = useState(initialValue);
  const handleChange = (e) => {
    setBlog({ ...blog, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(blog);
    postBlog(blog);
    navigate("/");
  };
  useEffect(() => {
    getCategoryName("categories");
  }, []);

  return (
    <div className="newBlog" style={{ textAlign: "center", padding: "1rem" }}>
      <Helmet>
        <title>NewBlog | Blogia</title>
        <meta name="description" content="Your page description" />
      </Helmet>
      <Box className="newcontent"
        sx={{
          mx: "auto",
          display: "flex",
          marginTop: "2rem",
          flexDirection: "column",
          gap: 2,
        }}
        component="form"
        onSubmit={handleSubmit}
        style={{
          width: "50%",
          border: "2px  solid black",
          borderRadius: "10px",
          padding: "1rem",
          backgroundColor: "rgba(255,255,255,0.7)",
          boxShadow: "10px 10px 25px white",
          color: "#1d3557",
        }}
      >
        <Typography
          style={{
            fontSize: "2rem",
            textTransform: "uppercase",
            fontWeight: "600",
          }}
        >
          New Blog
        </Typography>
        <TextField
          label="Title"
          name="title"
          id="title"
          type="text"
          variant="outlined"
          value={blog?.title}
          onChange={handleChange}
          required
        />
        <TextField
          label="Image URL"
          name="image"
          id="image"
          type="url"
          variant="outlined"
          value={blog?.image}
          onChange={handleChange}
          required
        />
        <FormControl>
          <InputLabel variant="outlined" id="category">
            Category
          </InputLabel>
          <Select
            labelId="categoryId"
            label="Category"
            id="categoryId"
            name="categoryId"
            value={blog?.categoryId}
            onChange={handleChange}
            required
          >
            <MenuItem disabled>Select the Category</MenuItem>
            <hr />
            {categories.map((item) => {
              return (
                <MenuItem key={item?._id} value={item?._id}>
                  {item.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel variant="outlined" id="status">
            Status
          </InputLabel>
          <Select
            labelId="status"
            label="Status"
            id="isPublish"
            name="isPublish"
            value={blog.isPublish}
            onChange={handleChange}
            required
          >
            <MenuItem disabled>Add New Product</MenuItem>
            <hr />
            {status.map((item, i) => (
              <MenuItem key={i} value={item.value}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Textarea
          placeholder="Content"
          label="Content"
          required
          name="content"
          id="content"
          variant="outlined"
          value={blog.content}
          minRows={2}
          maxRows={4}
          onChange={handleChange}
        />

        <Button
          className="newBlog-btn"
          type="submit"
          variant="contained"
          size="large"
        >
          Add Blog
        </Button>
      </Box>
    </div>
  );
};

export default NewBlog;
